var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1455"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 521",
    width: 50,
    height: 50,
    rx: 8,
    fill: "#234065"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.2191 25.0028C17.2191 20.704 20.7028 17.222 24.9996 17.222C27.5876 17.222 29.8756 18.4914 31.2886 20.4355L35.5698 17.4372C33.2128 14.146 29.3583 12 25.0021 12C17.8199 12 11.999 17.8212 11.999 25.0028C11.999 27.7302 12.8404 30.2602 14.2758 32.3507L18.5501 29.3548C17.7113 28.1142 17.2191 26.614 17.2191 25.0028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M36.9974 19.9805L25.1822 28.2518C25.1891 28.2473 29.2195 28.2473 32.0661 28.2495C30.8351 30.9238 28.1384 32.7812 25.0029 32.7812C23.3822 32.7812 21.8778 32.2842 20.6303 31.4364L16.1836 34.55C18.5001 36.6917 21.5985 38.001 25.0029 38.001C32.1842 38.001 38.0052 32.1798 38.0052 24.9983C38.0034 23.2206 37.6457 21.5251 36.9974 19.9805Z",
    fill: "#4B7FC1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGc);
export default __webpack_public_path__ + "static/media/gc.b9005298e8e04191225f6a0697cb65a5.svg";
export { ForwardRef as ReactComponent };